import { useAppDispatch } from '../redux_store/reduxStore';
import { debounce } from 'lodash';

export const useDebouncedFetch = () => {
  const dispatch = useAppDispatch();

  const fetchData = debounce(async (action: any, payload: any) => {
    try {
      await dispatch(action(payload));
    } catch (error) {
      console.error('Error during API call:', error);
    }
  }, 500);

  // working but cometned as
  // const fetchData = useCallback(
  //   debounce(async (action: any, payload: any) => {
  //     try {
  //       await dispatch(action(payload));
  //     } catch (error) {
  //       console.error('Error during API call:', error);
  //     }
  //   }, 500),
  //   [dispatch]
  // );

  return fetchData;
};
